import Headroom from 'headroom.js';

const onUnpin = function() {
    const headerCheckboxes = document.querySelectorAll('.header-menu__sub-menu-checkbox');
    headerCheckboxes.forEach(element => {
        element.checked = false;
    })
}

const headerElement = document.querySelector('.header-menu__headroom');
let headroom = null;
if (headerElement) {
    // construct an instance of Headroom, passing the element
    headroom = new Headroom(headerElement, {
        offset : 100,
        tolerance : 50,
        onUnpin: onUnpin,
    });

    // initialise
    headroom.init();
    if (document.documentElement.scrollTop > 400) {
        headroom.unpin();
    }
}

export { headroom };